import { Instant } from '@js-joda/core';
import { getProTraderStatusFromJwtClaims, ThinkAlphaJwtPayload } from '@thinkalpha/common/schemas/auth.js';
import type { ProTraderStatus } from '@thinkalpha/common/schemas/auth.js';
import { jwtDecode } from 'jwt-decode';

export class OAuth2CodeWrongOrExpiredError extends Error {
    constructor(description: string) {
        super(description);
    }
}

export function decodeToken(token: string): ThinkAlphaJwtPayload {
    const rawPayload: unknown = jwtDecode(token);
    return ThinkAlphaJwtPayload.parse(rawPayload);
}

export function getProTraderStatusFromToken(token: string | null | undefined): ProTraderStatus {
    if (!token) return 'unspecified';
    try {
        return getProTraderStatusFromJwtClaims(decodeToken(token));
    } catch {
        return 'unspecified';
    }
}

export function getExpirationDate(token: string): Instant | undefined {
    const payload = decodeToken(token);
    if (typeof payload.exp === 'number' && typeof payload.iat === 'number') {
        return Instant.ofEpochSecond(payload.exp);
    }
    return undefined;
}
